import React, { useState } from 'react';
import { translate } from '../Services/translation';

const OpenSoftubeCentral = ({ downloadMacUrl, downloadWindowsUrl }) => {
    const [opening, setOpening] = useState(false);
    const [showDownloadLinks, setShowDownloadLinks] = useState(false);

    const openSoftubeCentral = () => {
        if (!opening) {
            setOpening(true);
            if (downloadMacUrl && downloadWindowsUrl) {
                setTimeout(function() {
                        setShowDownloadLinks(true);
                }, 3000);
            }
        }
    }

    return (
        <div className="open-softube-central">
            {!showDownloadLinks ? (
                <div className="open-softube-central__open">
                    <a href="softubecentral://" className={`button ${opening ? "loading button--disabled" : ""}`} onClick={() => openSoftubeCentral()}>
                        <span>{translate('js.general.open')} {translate('js.general.softubecentral')}</span>
                        <span className="spinner spinner--light spinner--small"></span>
                    </a>
                    <div>
                        <button className="button button__link" onClick={() => setShowDownloadLinks(true)}>
                            <span>{translate('js.general.softubecentral.download.short.text')}</span>
                        </button>
                    </div>
                </div>
            ) : (
                <div className="open-softube-central__download">
                    <h5>{translate('js.general.softubecentral.download.text')}</h5>
                    <div className="buttons-row">
                        <a href={downloadMacUrl} target="_blank" className="button">
                            <i className="icon-apple"></i>
                            <span>{translate('js.general.mac')}</span>
                        </a>
                        <a href={downloadWindowsUrl} target="_blank" className="button">
                            <i className="icon-windows"></i>
                            <span>{translate('js.general.windows')}</span>
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OpenSoftubeCentral;
